import { cva } from '@landr/styled-system/css';

const SearchBarInputMin = '100px';

export const groupItemStyles = cva({
    base: {
        flexGrow: 10,
        minWidth: SearchBarInputMin,
        position: 'relative',
    },
    variants: {
        hasInput: {
            true: {
                minWidth: '0',
                display: 'flex',
            },
            false: {},
        },
    },
});

export const textStyles = cva({
    base: {
        whiteSpace: 'break-spaces',
        display: 'inline-block',
        fontWeight: '400',
        lineHeight: '1',
    },
    variants: {
        isTouchDevice: {
            true: {
                fontSize: 'md',
            },
        },
    },
});

export const autocompleteStyles = cva({
    base: {
        position: 'absolute',
        left: '0',
        top: '0.5px',
        bottom: '0',
        height: '100%',
        alignItems: 'center',
        padding: '0',
        border: '0',
        margin: '0',
        lineHeight: '1',
    },
    variants: {
        isMobile: {
            true: {
                paddingInline: 'xs',
            },
        },
    },
});

export const inputStyles = cva({
    base: {
        padding: '0',
        border: '0',
        height: '28px',
        minHeight: '28px',
        paddingInline: '0',
        display: 'flex',
        backgroundColor: 'transparent',
        _focusWithin: {
            boxShadow: 'none',
        },
        '& > input[type="search"]': {
            minWidth: '0',
            paddingLeft: '0',
            paddingRight: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            _disabled: {
                color: 'text.disabled',
                WebkitTextFillColor: 'text.disabled',
            },
        },
        '& [data-part="input"]': {
            paddingInline: '0',
        },
        '& [data-part="wrapper"]': {
            paddingInline: '0',
        },
    },
    variants: {
        hasValue: {
            true: {
                '& > input[type="search"]': {
                    width: 'auto',
                },
            },
            false: {
                '& > input[type="search"]': {
                    width: '100%',
                },
            },
        },
        isMobile: {
            true: {
                '& [data-part="input"]': {
                    paddingInline: 'xs',
                },
            },
            false: {},
        },
    },
});
